import React, { MouseEventHandler, ReactNode } from 'react';

import { Button, Tooltip, Row, Col } from 'antd';

import {
  FilterOutlined,
  ClearOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Label } from '@components/UI';
import * as S from './styles';

interface IFilters {
  isOpen?: boolean;
  onOpen?: MouseEventHandler<HTMLButtonElement>;
  onClear?: MouseEventHandler<HTMLButtonElement>;
  primaryColor?: string;
  title?: string;
  secondaryTitle?: string;
  icon?: any;
  hasValuesInFilters?: boolean;
}

export const Filters: React.FC<IFilters> = ({
  isOpen,
  onOpen,
  onClear,
  primaryColor,
  title,
  secondaryTitle,
  icon,
  hasValuesInFilters,
}) => {
  const { t } = useTranslation('table');

  return (
    <S.FiltersContainer>
      {title}
      <Tooltip
        title={secondaryTitle ?? t(`${isOpen ? 'hide' : 'display'}-filters`)}
      >
        <Button
          icon={icon ?? <FilterOutlined />}
          type={isOpen ? 'primary' : 'default'}
          className="filters-button"
          style={{ backgroundColor: primaryColor }}
          onClick={onOpen}
        />
      </Tooltip>
      {hasValuesInFilters && (
        <Tooltip title={t('clean-filters')}>
          <Button
            icon={<ClearOutlined />}
            className="filters-button-clear"
            style={{ backgroundColor: primaryColor }}
            onClick={onClear}
          />
        </Tooltip>
      )}
    </S.FiltersContainer>
  );
};

export interface ITableFilters {
  visible?: boolean;
  disabledTitle?: string;
  col?: {
    lg: number;
    xl: number;
    xs: number;
  };
  label: string;
  info?: string;
  element: ReactNode;
}

interface IFiltersCard {
  tableFilters: ITableFilters[];
  isOpen?: boolean;
}

export const FiltersCard: React.FC<IFiltersCard> = ({
  isOpen,
  tableFilters,
  ...props
}) => {
  if (!isOpen) {
    return <></>;
  }

  return (
    <S.FiltersCardContainer {...props}>
      <Row align="bottom" gutter={[16, 16]}>
        {tableFilters?.map(
          ({ col, label, info, element, visible, disabledTitle }) => {
            const { lg, xl, xs } = col ?? {
              lg: 10,
              xl: 8,
              xs: 24,
            };

            return (
              visible && (
                <Tooltip title={disabledTitle ?? ''}>
                  <Col key={label} lg={lg} xl={xl} xs={xs}>
                    {label && (
                      <Label htmlFor={label} style={{ display: 'block' }}>
                        {label}
                        {info && (
                          <Tooltip title={info}>
                            <Button
                              type="link"
                              size="small"
                              style={{ marginLeft: 4 }}
                              icon={<InfoCircleOutlined />}
                            />
                          </Tooltip>
                        )}
                      </Label>
                    )}
                    {element}
                  </Col>
                </Tooltip>
              )
            );
          },
        )}
      </Row>
    </S.FiltersCardContainer>
  );
};
